// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1388":"2b065acb","2322":"2b065acb","3265":"2b065acb","4564":"2b065acb","4971":"2b065acb","7958":"2b065acb","8592":"2b065acb","8840":"2b065acb","9592":"2b065acb"}[chunkId] + ".chunk.css";
};